import { VillaSidebarComponent } from './villa-results/villa-sidebar/sidebar.component';
import { VillaSingleComponent } from './villa-single/villa-single.component';
import { NgModule } from '@angular/core';
import { Routes, RouterModule } from '@angular/router';
import {NgbModule} from '@ng-bootstrap/ng-bootstrap';
import { CommonModule } from '@angular/common';
import { SharedModule } from '../../shared/components/shared.module';
import { FormsModule } from '@angular/forms';
import { NouisliderModule } from 'ng2-nouislider';
import { VillaCollectionComponent } from './villa-results/villa-results.component';
import { VillaCollectionService } from '../../core/services/villa-collection.service';
import { VillaCollectionContainer } from './villa-collection.container';
import { VillaPreviewComponent } from './villa-results/villa-preview/villa-preview.component';
import { RoomPeopleComponent } from './room-people/room-people.component';
import {VillaCollectionInitComponent} from './villa-collection-init.component';
import { NgxUsefulSwiperModule } from 'ngx-useful-swiper';

const routes: Routes = [
  { path: 'villa-collection', component: VillaCollectionInitComponent, children: [
      { path: '', component: VillaCollectionComponent },
      { path: '**', component: VillaSingleComponent }
    ]}
  ];

@NgModule({
  imports: [
      CommonModule,
      RouterModule.forRoot(routes),
      NgbModule,
      SharedModule,
      FormsModule,
      NouisliderModule,
      // ResultsModule,
      SharedModule,
      NgxUsefulSwiperModule
    ],
  declarations: [
    VillaCollectionComponent,
    VillaPreviewComponent,
    VillaSingleComponent,
    VillaSidebarComponent,
    RoomPeopleComponent,
    VillaCollectionInitComponent
    ],
    exports: [ RouterModule
      ],

    providers: [
        VillaCollectionService,
        VillaCollectionContainer
    ]
})
export class VillaCollectionModule {}
